interface MapIconProps {
  className?: string;
  aiId?: string;
}

export function NaverMapIcon({ className, aiId }: MapIconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className} data-ai-id={aiId}>
      <rect x="3" y="3" width="18" height="18" rx="5" fill="currentColor" data-ai-id={aiId ? `${aiId}-background-rect` : undefined} />
      <path
        d="M7.2 16.7V7.3h2.5l4.6 5.3V7.3h2.5v9.4h-2.4l-4.7-5.38v5.38H7.2Z"
        fill="white"
        data-ai-id={aiId ? `${aiId}-lettering-path` : undefined}
      />
    </svg>
  );
}
